import React from 'react'

import { PersonAvatar } from '@sketch/components'
import { AddProjectMemberNotificationFragment } from '@sketch/gql-types'

import { AvatarWrapper } from './AddShareMemberPreview.styles'
import { FolderTileMedia } from './FolderTileMedia'
import {
  Card,
  Separator,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
  RoleBadge,
} from './TileCard.styles'

interface AddProjectMemberPreviewProps {
  notification: AddProjectMemberNotificationFragment
}

export const AddProjectMemberPreview = ({
  notification,
}: AddProjectMemberPreviewProps) => {
  const { folder, user, workspace } = notification

  if (!folder || !user) return null

  const name = user.name ?? 'Someone'
  const avatarSrc = user.avatar?.small

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AvatarWrapper>
            {avatarSrc ? (
              <PersonAvatar
                flavour="image"
                size="96px"
                name={name}
                src={avatarSrc}
              />
            ) : (
              <PersonAvatar flavour="color" size="96px" name={name} />
            )}
          </AvatarWrapper>
          <TileTitle>{name}</TileTitle>
          <RoleBadge variant="secondary">Inviter</RoleBadge>
        </Tile>

        <Separator />

        <Tile>
          <FolderTileMedia folder={folder} />
          <TileTitle>{folder.name}</TileTitle>
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
